export { default as TermsAndConditionsWrapper } from './TermsAndConditionsWrapper';
export { default as TermsAndConditionsDialog } from './TermsAndConditionsDialog';
